import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_2 = { class: "input-group top_search" };
const _hoisted_3 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_4 = { class: "input-group top_search" };
const _hoisted_5 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", null, "Recent Alarms Period: ", -1 /* HOISTED */);
const _hoisted_7 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_8 = { class: "checkbox-wrapper" };
const _hoisted_9 = { class: "float-end float-start-sm" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* HOISTED */);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* HOISTED */);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_14 = {
    key: 0,
    class: "bottom10"
};
const _hoisted_15 = { class: "mt-0" };
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_17 = { class: "input-group top_search" };
const _hoisted_18 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_19 = { class: "input-group top_search" };
const _hoisted_20 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("label", null, "Recent Alarms Period: ", -1 /* HOISTED */);
const _hoisted_22 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_23 = { class: "checkbox-wrapper" };
const _hoisted_24 = { class: "float-end float-start-sm" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* HOISTED */);
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* HOISTED */);
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_radio = _resolveComponent("b-form-radio");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_modal = _resolveComponent("b-modal");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _directive_standard_or_higher = _resolveDirective("standard-or-higher");
    return (_ctx.isModal)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_b_modal, {
                modelValue: _ctx.showModal,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.showModal) = $event)),
                id: "modal-summary-status-report",
                "header-bg-variant": "normal",
                size: "lg"
            }, {
                title: _withCtx(() => [
                    _createTextVNode("\r\n\t\t\t\tSummary Status Report\r\n\t\t\t")
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "primary",
                            onClick: _ctx.generateSummaryStatusReport
                        }, {
                            default: _withCtx(() => [
                                _hoisted_10,
                                _createTextVNode(" Export PDF\r\n\t\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]),
                        _createTextVNode(),
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "primary",
                            onClick: _ctx.exportToCsv
                        }, {
                            default: _withCtx(() => [
                                _hoisted_11,
                                _createTextVNode(" Export CSV\r\n\t\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]),
                        _createTextVNode(),
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "secondary",
                            onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.showModal = false))
                        }, {
                            default: _withCtx(() => [
                                _hoisted_12,
                                _createTextVNode(" Close\r\n\t\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ]),
                default: _withCtx(() => [
                    _createTextVNode(),
                    _createVNode(_component_b_container, { clearfix: "" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_multiselect, {
                                        modelValue: _ctx.selectedCompanyId,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                                        options: _ctx.companies,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "All companies",
                                        class: "multiselect-small",
                                        useTeleport: true
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options"])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_component_multiselect, {
                                        modelValue: _ctx.selectedSite,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedSite) = $event)),
                                        options: _ctx.sitesFiltered,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "Any site",
                                        class: "multiselect-small",
                                        useTeleport: true
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options"])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_5, [
                                _hoisted_6,
                                _createTextVNode(),
                                _createVNode(_component_b_form_group, { label: "" }, {
                                    default: _withCtx(({ ariaDescribedby }) => [
                                        _createVNode(_component_b_form_radio, {
                                            inline: "",
                                            modelValue: _ctx.recentAlarmsPeriod,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.recentAlarmsPeriod) = $event)),
                                            "aria-describedby": ariaDescribedby,
                                            name: "recentAlarmsPeriod",
                                            value: "7"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode("7 days")
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "aria-describedby"]),
                                        _createTextVNode(),
                                        _createVNode(_component_b_form_radio, {
                                            inline: "",
                                            modelValue: _ctx.recentAlarmsPeriod,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.recentAlarmsPeriod) = $event)),
                                            "aria-describedby": ariaDescribedby,
                                            name: "recentAlarmsPeriod",
                                            value: "28"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode("4 weeks")
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "aria-describedby"])
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _createTextVNode(),
                            _createCommentVNode("<div class=\"col-xs-12 col-sm-12 col-md-6\">\r\n\t\t<div class=\"input-group top_search\">\r\n\t\t\t<multiselect v-model=\"alarmType\" :options=\"alarmTypes\" track-by=\"value\" label=\"text\" :showLabels=\"false\" placeholder=\"Any Alarm Type\" class=\"multiselect-small\">\r\n\t\t\t\t<template #noResult>\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t</template>\r\n\t\t\t</multiselect>\r\n\t\t</div>\r\n\t</div>\r\n\t<div class=\"col-xs-12 col-sm-12 col-md-6\">\r\n\t\t<div class=\"input-group top_search\">\r\n\t\t\t<multiselect :options=\"systemStates\"\r\n\t\t\t\t\t\t track-by=\"value\"\r\n\t\t\t\t\t\t label=\"text\"\r\n\t\t\t\t\t\t :multiple=\"true\"\r\n\t\t\t\t\t\t :showLabels=\"false\"\r\n\t\t\t\t\t\t placeholder=\"\"\r\n\t\t\t\t\t\t :preserveSearch=\"true\"\r\n\t\t\t\t\t\t :closeOnSelect=\"false\"\r\n\t\t\t\t\t\t class=\"multiselect-small\">\r\n\t\t\t\t<template #noResult>\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t</template>\r\n\t\t\t\t<template #placeholder>\r\n\t\t\t\t\t<span v-if=\"!numberOfSeletedStatus\">\r\n\t\t\t\t\t\tNone selected\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</template>\r\n\t\t\t\t<template #selection=\"{ search, isOpen }\">\r\n\t\t\t\t\t<span class=\"multiselect__single\" v-if=\"numberOfSeletedStatus && !isOpen\">{{ statusOptionText }}</span>\r\n\t\t\t\t</template>\r\n\t\t\t\t<template #option=\"props\">\r\n\t\t\t\t\t<div @click.stop=\"selectStatus(props.option)\">\r\n\t\t\t\t\t\t<b-form-checkbox :id=\"'status-' + props.option.value\" :key=\"getComponentKey(props.option)\" :checked=\"props.option.selected\">\r\n\t\t\t\t\t\t\t<label class=\"font-weight-normal\">\r\n\t\t\t\t\t\t\t\t{{ props.option.text }}\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t</b-form-checkbox>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</template>\r\n\t\t\t</multiselect>\r\n\t\t</div>\r\n\t</div>"),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_b_form_checkbox, {
                                        modelValue: _ctx.hideSiteName,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.hideSiteName) = $event)),
                                        size: "lg"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\tHide site name columns\r\n\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue"])
                                ])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createTextVNode()
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]),
            _createTextVNode(),
            _createVNode(_component_StatusOverlayComponent, {
                visible: _ctx.working,
                message: "Loading..."
            }, null, 8 /* PROPS */, ["visible"])
        ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_13, [
                (_ctx.reportScheduledModel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("h2", _hoisted_15, [
                            _createTextVNode("Editing schedule report "),
                            _createElementVNode("b", null, _toDisplayString(_ctx.reportScheduledModel.description), 1 /* TEXT */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_multiselect, {
                        modelValue: _ctx.selectedCompanyId,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                        options: _ctx.companies,
                        "track-by": "value",
                        label: "text",
                        showLabels: false,
                        placeholder: "All companies",
                        class: "multiselect-small"
                    }, {
                        noResult: _withCtx(() => [
                            _createTextVNode("\r\n\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "options"])
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_multiselect, {
                        modelValue: _ctx.selectedSite,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.selectedSite) = $event)),
                        options: _ctx.sitesFiltered,
                        "track-by": "value",
                        label: "text",
                        showLabels: false,
                        placeholder: "Any site",
                        class: "multiselect-small"
                    }, {
                        noResult: _withCtx(() => [
                            _createTextVNode("\r\n\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "options"])
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createTextVNode(),
                _createVNode(_component_b_form_group, { label: "" }, {
                    default: _withCtx(({ ariaDescribedby }) => [
                        _createVNode(_component_b_form_radio, {
                            inline: "",
                            modelValue: _ctx.recentAlarmsPeriod,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.recentAlarmsPeriod) = $event)),
                            "aria-describedby": ariaDescribedby,
                            name: "recentAlarmsPeriod",
                            value: "7"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode("7 days")
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "aria-describedby"]),
                        _createTextVNode(),
                        _createVNode(_component_b_form_radio, {
                            inline: "",
                            modelValue: _ctx.recentAlarmsPeriod,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.recentAlarmsPeriod) = $event)),
                            "aria-describedby": ariaDescribedby,
                            name: "recentAlarmsPeriod",
                            value: "28"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode("4 weeks")
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "aria-describedby"])
                    ]),
                    _: 1 /* STABLE */
                })
            ]),
            _createTextVNode(),
            _createCommentVNode("<div class=\"col-xs-12 col-sm-12 col-md-6\">\r\n\t\t<div class=\"input-group top_search\">\r\n\t\t\t<multiselect v-model=\"alarmType\" :options=\"alarmTypes\" track-by=\"value\" label=\"text\" :showLabels=\"false\" placeholder=\"Any Alarm Type\" class=\"multiselect-small\">\r\n\t\t\t\t<template #noResult>\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t</template>\r\n\t\t\t</multiselect>\r\n\t\t</div>\r\n\t</div>\r\n\t<div class=\"col-xs-12 col-sm-12 col-md-6\">\r\n\t\t<div class=\"input-group top_search\">\r\n\t\t\t<multiselect :options=\"systemStates\"\r\n\t\t\t\t\t\t track-by=\"value\"\r\n\t\t\t\t\t\t label=\"text\"\r\n\t\t\t\t\t\t :multiple=\"true\"\r\n\t\t\t\t\t\t :showLabels=\"false\"\r\n\t\t\t\t\t\t placeholder=\"\"\r\n\t\t\t\t\t\t :preserveSearch=\"true\"\r\n\t\t\t\t\t\t :closeOnSelect=\"false\"\r\n\t\t\t\t\t\t class=\"multiselect-small\">\r\n\t\t\t\t<template #noResult>\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t</template>\r\n\t\t\t\t<template #placeholder>\r\n\t\t\t\t\t<span v-if=\"!numberOfSeletedStatus\">\r\n\t\t\t\t\t\tNone selected\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</template>\r\n\t\t\t\t<template #selection=\"{ search, isOpen }\">\r\n\t\t\t\t\t<span class=\"multiselect__single\" v-if=\"numberOfSeletedStatus && !isOpen\">{{ statusOptionText }}</span>\r\n\t\t\t\t</template>\r\n\t\t\t\t<template #option=\"props\">\r\n\t\t\t\t\t<div @click.stop=\"selectStatus(props.option)\">\r\n\t\t\t\t\t\t<b-form-checkbox :id=\"'status-' + props.option.value\" :key=\"getComponentKey(props.option)\" :checked=\"props.option.selected\">\r\n\t\t\t\t\t\t\t<label class=\"font-weight-normal\">\r\n\t\t\t\t\t\t\t\t{{ props.option.text }}\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t</b-form-checkbox>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</template>\r\n\t\t\t</multiselect>\r\n\t\t</div>\r\n\t</div>"),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_b_form_checkbox, {
                        modelValue: _ctx.hideSiteName,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.hideSiteName) = $event)),
                        size: "lg"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode("\r\n\t\t\t\t\tHide Site Name Columns\r\n\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_24, [
                _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                    type: "button",
                    variant: "primary",
                    onClick: _ctx.schedule
                }, {
                    default: _withCtx(() => [
                        _hoisted_25,
                        _createTextVNode(" " + _toDisplayString(_ctx.getScheduleButtonLabel()), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])), [
                    [_directive_standard_or_higher]
                ]),
                _createTextVNode(),
                _createVNode(_component_b_button, {
                    type: "button",
                    variant: "primary",
                    onClick: _ctx.generateSummaryStatusReport
                }, {
                    default: _withCtx(() => [
                        _hoisted_26,
                        _createTextVNode(" Export PDF\r\n\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"]),
                _createTextVNode(),
                _createVNode(_component_b_button, {
                    type: "button",
                    variant: "primary",
                    onClick: _ctx.exportToCsv
                }, {
                    default: _withCtx(() => [
                        _hoisted_27,
                        _createTextVNode(" Export CSV\r\n\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
            ]),
            _createTextVNode(),
            _createVNode(_component_StatusOverlayComponent, {
                visible: _ctx.working,
                message: "Loading..."
            }, null, 8 /* PROPS */, ["visible"])
        ], 64 /* STABLE_FRAGMENT */));
}
